<template>
  <div>               
    <ul class="nav nav-tabs">      
      <router-link to='/admin/carforsaleaddpre' tag='li' active-class='active'><a>Agregar vehiculo</a></router-link>
      <router-link to='/admin/inquiryadmin'     tag='li' active-class='active'><a>Cotizaciones</a></router-link>
      <router-link to='/admin/carforsaleadmin'  tag='li' active-class='active'><a>Vehiculos en venta</a></router-link>
      <router-link to='/admin/bankadmin'        tag='li' active-class='active'><a>Bancos</a></router-link>
      <router-link to='/admin/carbrandadmin'    tag='li' active-class='active'><a>Marcas de vehiculos</a></router-link>            
    </ul>    
    <hr>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
   
    }
  },
  mounted: function () {        
    
  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// AdminNav.vue?64d1385e